"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.processData = void 0;
var react_1 = __importDefault(require("react"));
var react_chartjs_2_1 = require("react-chartjs-2");
var moment_1 = __importDefault(require("moment"));
var core_1 = require("@material-ui/core");
var BaseStatisticsLayout_1 = __importDefault(require("./BaseStatisticsLayout"));
var date_range_1 = require("./util/date-range");
var format_1 = require("../../../../../app/util/format");
var DownloadClicksButton_1 = __importDefault(require("./widgets/DailyStatistics/DownloadClicksButton"));
function processData(data, primaryColor) {
    var labels = data.map(function (day) {
        return moment_1.default(day.date, 'yyyy-MM-DD').format('D MMM');
    });
    var points = data.map(function (day) { return day.clicks; });
    var datasets = [
        {
            fill: false,
            lineTension: 0,
            backgroundColor: primaryColor,
            borderColor: primaryColor,
            pointColor: primaryColor,
            pointHitRadius: 20,
            pointStrokeColor: primaryColor,
            pointRadius: 0,
            pointHoverRadius: 5,
            data: points,
        },
    ];
    return { labels: labels, datasets: datasets };
}
exports.processData = processData;
function DailyStatistics(_a) {
    var dailyClicks = _a.dailyClicks;
    var theme = core_1.useTheme();
    var filledData = date_range_1.useDateRangeWith(dailyClicks, 7);
    var primaryColor = theme.palette.primary.main;
    var data = processData(filledData, primaryColor);
    return (react_1.default.createElement(BaseStatisticsLayout_1.default, { title: "How many users have visited your link in the past week?", subtitle: react_1.default.createElement(DownloadClicksButton_1.default, null) },
        react_1.default.createElement(react_chartjs_2_1.Line, { data: data, legend: { display: false }, options: {
                scales: {
                    xAxes: [
                        {
                            gridLines: {
                                display: false,
                            },
                            ticks: {
                                fontFamily: "'IBM Plex Sans', sans-serif",
                                fontSize: 12,
                                fontColor: primaryColor,
                                padding: 8,
                                callback: function (label) {
                                    return moment_1.default(label, 'D MMM').format('ddd');
                                },
                            },
                        },
                    ],
                    yAxes: [
                        {
                            ticks: {
                                fontFamily: "'IBM Plex Sans', sans-serif",
                                fontSize: 12,
                                fontColor: primaryColor,
                                autoSkip: true,
                                maxTicksLimit: 5,
                                padding: 5,
                                min: 0,
                                callback: function (label) {
                                    // Prevents decimals on the y-axis.
                                    if (Math.floor(label) === label) {
                                        return format_1.compactNumberFormatter(label);
                                    }
                                    return undefined;
                                },
                            },
                        },
                    ],
                },
                tooltips: {
                    callbacks: {
                        title: function (tooltipItems, data) {
                            var _a, _b, _c;
                            var index = (_a = tooltipItems[0].index) !== null && _a !== void 0 ? _a : 0;
                            var label = (_c = (_b = data.labels) === null || _b === void 0 ? void 0 : _b[index].toString()) !== null && _c !== void 0 ? _c : '';
                            var fullDate = moment_1.default(label, 'D MMM').format('DD MMMM yyyy');
                            return fullDate.toString();
                        },
                        label: function (tooltipItem) {
                            var label = tooltipItem.yLabel;
                            return label + " total clicks";
                        },
                    },
                    xPadding: 20,
                    yPadding: 20,
                    titleFontFamily: "'IBM Plex Sans', sans-serif",
                    bodyFontFamily: "'IBM Plex Sans', sans-serif",
                    titleFontSize: 10,
                    bodyFontSize: 14,
                    titleFontColor: primaryColor,
                    bodyFontColor: primaryColor,
                    titleFontStyle: 'normal',
                    bodyFontStyle: 'bold',
                    backgroundColor: '#FFFFFF',
                    borderColor: theme.palette.secondary.dark,
                    borderWidth: 0.2,
                    displayColors: false,
                },
            } })));
}
exports.default = DailyStatistics;
